export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-26-C-front-side-back-WEB-THUMB-7345eceb70961f9e573aa240917daaf1.jpg";